export default __webpack_public_path__ + "static/media/footer.e8bee268.png";